<template>
  <div>
    <b-modal
      ref="requestSuccessModal"
      body-class="p-0"
      hide-header
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="header px-3 pt-3">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <b-icon-exclamation-circle-fill class="icon-check mr-2" />
            <h4 class="mb-0 text-uppercase modal-title">
              {{ $t('invoices.requestQuery.modal.successTitle') }}
            </h4>
          </div>
          <div class="text-right">
            <b-link class="text-secondary mr-2 h3" @click="hide()">
              <b-icon-x class="text-muted" />
            </b-link>
          </div>
        </div>
      </div>
      <div class="content px-3">
        <p class="my-4 message">
          {{ $t('invoices.requestQuery.modal.successMessage') }}
        </p>
      </div>
      <div class="footer">
        <hr />
        <div class="text-right">
          <b-button
            size="sm"
            class="py-2 px-4 mb-3 mr-4 text-uppercase font-header"
            variant="secondary"
            @click="hide()"
          >
            {{ $t('dashboard.accountNumbers.requestModal.ok') }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  methods: {
    hide() {
      this.$refs['requestSuccessModal'].hide()
    },
    show() {
      this.$refs['requestSuccessModal'].show()
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/scss/variables';
.icon-check {
  font-size: 2rem;
  margin-top: -0.5rem;
  color: $primary;
}
.modal-title {
  letter-spacing: 1px;
  font-family: $montserrat;
  color: $secondary;
  font-size: large;
}
.font-header {
  font-family: $montserrat;
}
.message {
  font-family: $lato;
  color: $dc-input-color;
}
.footer {
  background-color: $dc-actions-bg;
}
</style>
